export default {
    en: {
        createNewEntry: 'Create New Entry',
        title: 'Title',
        subtitle: 'Subtitle',
        intro: 'Intro',
        story: 'Story',
        publishEntry: 'Publish entry',
        advancedOptions: 'Advanced options',
        sensitiveContent: 'Sensitive content',
        sensitiveContentDescription: 'Media related to religious- or political beliefs, or considered erotic- or gore content',
        historicalTime: 'Historical time',
        historicalTimeDescription: 'People may browse your feed based on historical event order. If not set, people will always see your entries in upload order.',
        createEntry: 'Create entry'
    },
    hu: {
        createNewEntry: 'Új bejegyzés létrehozása',
        title: 'Cím',
        subtitle: 'Alcím',
        intro: 'Bevezetés',
        story: 'Történet',
        publishEntry: 'Bejegyzés közzététele',
        advancedOptions: 'További beállítások',
        sensitiveContent: 'Érzékeny tartalom',
        sensitiveContentDescription: 'Olyan médiatartalom, ami vallási- vagy politikai nézetekhez köthető, vagy erotikus- vagy durva tartalomnak minősül',
        historicalTime: 'Esemény időpontja',
        historicalTimeDescription: 'Az emberek böngészhetik a bejegyzéseidet az események történelmi időpontja alapján. Ha nem adod meg, akkor mindig feltöltés szerinti sorrendben fogják látni.',
        createEntry: 'Create entry'
    }
}